import { SpottedVehicleReportListQuery } from '@rapid-recovery-agency-inc/insightt-graphql';

export interface ExportSpottedVehicleReportCsv {
  isLoading: boolean;
  isLoadingChunk: boolean;
  progress: number;
  chunkSize: number;
  chunkCount: number;
  total: number;
  records: SpottedVehicleReportListQuery['spottedVehicleReports'];
  csvArray: string[];
}

const CSV_HEADERS = ['Date', 'Time', 'VIN', 'Spotted By', 'Spot branch', 'Status', 'Order Type'];

export const EXPORT_SPOTTED_VEHICLES_CSV_INITIAL_STATE: ExportSpottedVehicleReportCsv = {
  isLoading: false,
  isLoadingChunk: false,
  progress: 0,
  chunkSize: 500,
  chunkCount: 0,
  total: 0,
  records: [],
  csvArray: [CSV_HEADERS.join(', ')],
};

export enum SpottedVehiclesActions {
  START_EXPORT_REPORT_CSV = 'SPOTTED_VEHICLES/START_EXPORT_REPORT_CSV',
  FETCH_CHUNK_REPORT_CSV = 'SPOTTED_VEHICLES/FETCH_CHUNK_REPORT_CSV',
  RESET = 'SPOTTED_VEHICLES/RESET',
}

export interface ExportSpottedVehiclesReportInput {
  startDate: string;
  endDate: string;
  branch: number;
  take?: number;
  skip?: number;
}
